<template>
  <div class="life_costs-pages-prestore-list content-container" id="life_costs-pages-prestore-list">
    <div class="container-scroll">
      <form name="loginform" id="formExport" action method="post" target="_blank">
        <input type="hidden" id="mchGroupCode" name="mchGroupCode" />
        <input type="hidden" id="mchSiteNo" name="mchSiteNo" />
        <input type="hidden" id="mchOrderNo" name="mchOrderNo" />
        <input type="hidden" id="mchOrderDttm" name="mchOrderDttm" />
        <input type="hidden" id="goodsTitle" name="goodsTitle" />
        <input type="hidden" id="goodsDetail" name="goodsDetail" />
        <input type="hidden" id="orderAmount" name="orderAmount" />
        <input type="hidden" id="chnlMchCode" name="chnlMchCode" />
        <input type="hidden" id="chnlMchName" name="chnlMchName" />
        <input type="hidden" id="mchCustId" name="mchCustId" />
        <input type="hidden" id="mchCustName" name="mchCustName" />
        <input type="hidden" id="mchCustIp" name="mchCustIp" />
        <input type="hidden" id="mchCustMac" name="mchCustMac" />
      </form>
      <!--导航部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>费用预存</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <!--导航部分 end-->
      <!--search部分-->
      <section class="layout-pad-full layout-pad-top-nil layout-margin-bottom back-white">
          <h1 class="holder-title">搜索条件</h1>
          <a-form class="cabinvue-search-form">
              <a-row :gutter="24">
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>客户号：</span>
                          </div>
                          <div class="item-control">
                              <a-input v-model="condition.custCode" placeholder="请输入客户号" />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>客户名：</span>
                          </div>
                          <div class="item-control">
                              <a-input v-model="condition.custName" placeholder="请输入客户名" />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>预存日期：</span>
                          </div>
                          <div class="item-control">
                              <a-range-picker
                                style="width:100%;"
                                :ranges="{ 
                                  '今天': [$moment().startOf('day'), $moment().endOf('day')],
                                  '昨天': [$moment().subtract(1, 'days').startOf('day'), $moment().subtract(1, 'days').endOf('day')],
                                  '最近一周': [$moment().subtract(7, 'days').startOf('day'), $moment().endOf('day')],
                                  '本月': [$moment().startOf('month'), $moment().endOf('month')] 
                                }"
                                v-model="pageData.dateList"
                                @change="dateListChange"
                                format="YYYY-MM-DD"
                                :placeholder="['开始日期', '结束日期']"
                              />
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <hr />
              <div class="form-option-area">
                  <a-button icon="search" class="space-margin-right" type="primary" :loading="tableObj.tableLoading"
                      @click.stop="search">查询</a-button>
                  <a-button icon="reload" class="space-margin-right btn-outline" @click.stop="resetEvt">重置</a-button>
              </div>
          </a-form>
      </section>
      <!--search部分 end-->
      <!--表格部分-->
      <section class="layout-table layout-pad-full layout-margin-bottom back-white">
        <div class="table-option-area space-margin-bottom">
          <a-button icon="plus" type="primary" @click.stop="add">新建</a-button>
        </div>
        <a-table 
          size="middle" 
          class="J_compensation_list_table" 
          :columns="tableObj.columns"
          :scroll="tableObj.scroll"
          :data-source="tableObj.list" 
          :pagination="false" 
          :loading="tableObj.tableLoading"
          >
          <template slot="action" slot-scope="text, record">
            <a href="javascript:;" @click="sysYcOrderInfo(record.prestoreOrderNo)" :disabled="record.payStatus === '3' || (record.payStatus === '2' && record.addFlag === '1')">同步查询</a>
          </template>
        </a-table>
        <div class="clearfix">
          <a-pagination style="margin-top:8px;float: right;" show-size-changer @change="pagination.change"
              @showSizeChange="pagination.showSizeChange" :default-current="pagination.defaultCurrent"
              v-model="pagination.current" :defaultPageSize="pagination.defaultPageSize" :total="pagination.total"
              :show-quick-jumper="pagination.showQuickJumper" :page-size-options="pagination.pageSizeOptions"
              :show-total='pagination.showTotal'>
          </a-pagination>
        </div>
      </section>
      <!--表格部分 end-->
      <a-drawer title="客户信息" :visible="drawer.visible" @close="close" placement="right" width="50%">
        <section class="layout-pad-full layout-pad-top-nil layout-margin-bottom back-white">
          <a-form class="cabinvue-search-form">
              <a-row :gutter="24">
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>客户姓名</span>
                          </div>
                          <div class="item-control">
                            <a-input v-model="drawer.defaultValue.custName" disabled />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>手机号</span>
                          </div>
                          <div class="item-control">
                            <a-input v-model="drawer.defaultValue.custPhone" disabled />
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <hr />
              <a-row :gutter="24">
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>项目</span>
                          </div>
                          <div class="item-control">
                            <a-select v-model="drawer.defaultValue.communityId" @change="communityChange">
                              <a-select-option v-for="item in pageData.custList" :key="item.communityId" :value="item.communityId">{{item.communityName}}</a-select-option>
                            </a-select>
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>资源编号</span>
                          </div>
                          <div class="item-control">
                            <a-select v-model="drawer.defaultValue.resourceCode" @change="resourceChange">
                              <a-select-option v-for="item in pageData.resourceList" :key="item.resourceCode" :value="item.resourceCode">{{item.resourceCode}}</a-select-option>
                            </a-select>
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <a-row :gutter="24">
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-control">
                            <a-input placeholder="资源名称" v-model="drawer.defaultValue.resourceName" disabled />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-control">
                            <a-select placeholder="资源类型" v-model="drawer.defaultValue.objType" disabled>
                              <a-select-option v-for="item in pageData.resInstTypeList" :key="item.code" :value="item.code">{{item.value}}</a-select-option>
                            </a-select>
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-control">
                            <a-input placeholder="资源ID" v-model="drawer.defaultValue.resourceId" disabled />
                          </div>
                      </div>
                  </a-col>
              </a-row>
          </a-form>
        </section>
        <section class="layout-table layout-pad-full layout-margin-bottom back-white">
          <a-table 
            size="middle" 
            class="J_compensation_list_table" 
            :row-selection="{ selectedRowKeys: drawer.selectedRowKeys, onChange: selectedRowKeysChange }"
            :columns="drawer.columns"
            :data-source="drawer.list" 
            :pagination="false" 
            :loading="tableObj.tableLoading"
            >
            <template slot="payProjectAmount" slot-scope="text, record">
              <a-input-number v-model="record.payProjectAmount" :min="0" @change="totalAmountChange" :formatter="value => `${value}元`" :parser="value => value.replace('元', '')" />
            </template>
          </a-table>
        </section>
        <section class="layout-table layout-pad-full layout-margin-bottom back-white" style="padding-bottom: 70px;">
          <a-alert message="预存" description="注意：预存金额会优先抵扣欠费，本次预存金额会根据欠费金额进行扣减" type="warning" style="margin-bottom:10px;" />
          <a-form class="cabinvue-search-form">
              <a-row :gutter="24">
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>缴费方式</span>
                          </div>
                          <div class="item-control">
                            <a-select v-model="drawer.defaultValue.payType">
                              <a-select-option v-for="item in pageData.payTypeList" :disabled="item.flag !== '1'" :key="item.code" :value="item.code">{{item.value}}</a-select-option>
                            </a-select>
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <a-row :gutter="24">
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>预存总额</span>
                          </div>
                          <div class="item-control">
                            <a-input-number style="width: 100%;"  disabled v-model="drawer.defaultValue.totalAmount" :min="0" :formatter="value => `${value}元`" :parser="value => value.replace('元', '')" />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>预存日期</span>
                          </div>
                          <div class="item-control">
                            <a-date-picker style="width: 100%;" v-model="drawer.defaultValue.currentDate" disabled />
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <a-row :gutter="24">
                  <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>备注</span>
                          </div>
                          <div class="item-control">
                            <a-textarea v-model="drawer.defaultValue.remark" :auto-size="{ minRows: 2, maxRows: 10 }" />
                          </div>
                      </div>
                  </a-col>
              </a-row>
          </a-form>
        </section>
        <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="close">关闭</a-button>
        <a-button type="primary" @click="submit">提交</a-button>
      </div>
      </a-drawer>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NP from 'number-precision'
import ajax from '../../lib/axios/ajax'
import { PRESTORE_LIST,PAYBILL_QUERYCOMMUNITYCUSTLIST, PRESTORE_QUERYRESOURCE, PRESTORE_QUERYPRESTORESCHEME, POST_PAYBILL_QUERYPAYSTATEENUM,PRESTORE_INSERPRESTORE, PRESTORE_POSINSERPRESTORE, POST_PAYBILL_GETPAYPAPER, PRESTORE_SYSYCORDERINFO, POST_PAYBILL_QUERYCOMMUNITYCUSTLIST } from '../../lib/axios/apilist'

export default {
//这里必须 使用一个方法返回给data
  data: function () {
    // 请求地址
    let ajaxParam = {
      PRESTORE_LIST: PRESTORE_LIST,
      PAYBILL_QUERYCOMMUNITYCUSTLIST: PAYBILL_QUERYCOMMUNITYCUSTLIST,
      PRESTORE_QUERYRESOURCE: PRESTORE_QUERYRESOURCE,
      PRESTORE_QUERYPRESTORESCHEME: PRESTORE_QUERYPRESTORESCHEME,
      POST_PAYBILL_QUERYPAYSTATEENUM: POST_PAYBILL_QUERYPAYSTATEENUM,
      PRESTORE_INSERPRESTORE: PRESTORE_INSERPRESTORE,
      PRESTORE_POSINSERPRESTORE: PRESTORE_POSINSERPRESTORE,
      POST_PAYBILL_GETPAYPAPER: POST_PAYBILL_GETPAYPAPER,
      PRESTORE_SYSYCORDERINFO: PRESTORE_SYSYCORDERINFO,
      POST_PAYBILL_QUERYCOMMUNITYCUSTLIST: POST_PAYBILL_QUERYCOMMUNITYCUSTLIST
    };
    //分页信息
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };

    let condition = {
      custCode: undefined, // 客户编码
      custName: undefined, // 客户名称
      startDate: undefined, // 预存开始日期
      endDate: undefined, // 预存结束日期
      custPhone: undefined, // 客户手机号
    }
    let tableObj = {
      tableLoading: false,
      list: [],
      scroll: {
        x: 2500,
      },
      columns: [{
        title: '预存订单号',
        dataIndex: 'prestoreOrderNo',
      },{
        title: '客户号',
        dataIndex: 'custCode',
      },{
        title: '客户名',
        dataIndex: 'custName',
      },{
        title: '资源范围',
        dataIndex: 'resourceName',
      },{
        title: '账本类型',
        dataIndex: 'accountBookDesc',
      },{
        title: '店号',
        dataIndex: 'mchNo',
      },{
        title: '店名',
        dataIndex: 'mchName',
      },{
        title: '预存金额',
        dataIndex: 'payProjectAmount',
      },{
        title: '缴费渠道',
        dataIndex: 'payType',
      },{
        title: '支付范围',
        dataIndex: 'payProject',
      },{
        title: '支付状态',
        dataIndex: 'payStatusName',
      },{
        title: '是否新增',
        dataIndex: 'addFlagName',
      },{
        title: '预存日期',
        dataIndex: 'crtDatetime',
      },{
        title: '操作',
        dataIndex: 'action',
        fixed: 'right',
        scopedSlots: { customRender: 'action' },
      }
    ]
    }
    let pageData = {
      dateList: [],
      custList: [],
      resourceList: [],
      resInstTypeList: [],
      payTypeList: []
    }
    let drawer = {
      visible: false,
      defaultValue: {
        resInstCodeExt: undefined, 
        accountBookType: undefined, // 账本类型
        custPhone: undefined, // 客户手机号
        custId: undefined, // 客户号
        custCode: undefined, // 客户编码
        custName: undefined, // 客户名称
        communityId: undefined, // 真实项目ID
        mchNo: undefined, // 门店号（项目编码）
        mchName: undefined, // 门店号（项目编码）
        objType: undefined, // 对象类型(资源类型)
        resourceId: undefined, // 资源id (铺位)
        resourceName: undefined, // 资源名称
        resourceCode: undefined, // 资源编码
        totalAmount: 0, // 缴费总金额
        payType: "85", // 账本类型  广发支付
        currentDate: moment(),
        remark: undefined, // 备注
        list: []
      },
      selectedRowKeys: [],
      columns: [
        { title: '方案名称', dataIndex: 'prestoreSchemeName', },
        { title: '账本类型', dataIndex: 'accountBookDesc', },
        { title: '可抵扣科目', dataIndex: 'payProject', },
        { title: '金额', dataIndex: 'payProjectAmount', scopedSlots: { customRender: 'payProjectAmount' }, },
      ],
      list: []
    }
    return {
      drawer,
      pageData,
      pagination,
      condition,
      tableObj,
      ajaxParam,
      children: [],
    }
  },
  mounted() {
    //进入页面
    //cabinVue 里面所有的this 都指向当前这个vue 实例
    //vue 更多使用方法请查看vue官方文档
    this.$nextTick(function () {
      //nextTick 用于当data数据改变,触发vue 渲染,且渲染完毕使用
      let custPhone = $('.J_partner_headcont i').attr('username')
      this.condition.custPhone = custPhone
      this.initFunc()
    });
    
  },
  //如果 不需要保存页面状态必须添加下面这个方法
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    //离开页面方法
    
  },
  //监听属性变化，，变量必须是data里声明的
  watch: {
  },
  //监听属性变化，配置变量的同时也起到data声明的作用
  computed: {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 日期选择
    dateListChange(date, dateString) {
      if (dateString) {
        this.condition.startDate = dateString[0]; // 处理时间开始
        this.condition.endDate = dateString[1]; // 处理时间结束
      } else {
        this.pageData.dateList = [];
      }
    },
    initFunc(){
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYPAYSTATEENUM;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.pageData.resInstTypeList = res.data.resInstTypeList;
          this.pageData.payTypeList = res.data.paymentEnumList;
          
          this.search();
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    // table查询搜索
    search(startFlag = true, param = {}, tempPagination = this.pagination) {
      let custPhone = $('.J_partner_headcont i').attr('username')
      this.condition.custPhone = custPhone
      let searchParam = {
        ...this.condition
      }
      // 开启加载效果
      this.tableObj.tableLoading = true;
      //浅复制
      let requestParam = Object.assign({}, searchParam, param);
      let currentPageNo = tempPagination.current;
      let currentPageSize = tempPagination.pageSize;
      if (startFlag) {
        requestParam.currentPage = 1;
      } else {
        requestParam.currentPage = currentPageNo;
      }
      requestParam.pageSize = currentPageSize;

      // 清空table数据
      this.tableObj.list.splice(0, this.tableObj.list.length);

      let that = this;
      let successFunc = (res) => {
        // 关闭加载效果
        this.tableObj.tableLoading = false;
        if (res.code === "0000") {
          this.pagination.current = res.data.page.currentPage;
          this.pagination.defaultCurrent = res.data.page.currentPage;
          this.pagination.pageSize = res.data.page.pageSize;
          this.pagination.total = res.data.page.totalCount;
          this.tableObj.list = res.data.page.result
          //调整TABLE样式
          that.$nextTick(function () {
            that.tableObj.scroll.x = 150 * that.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = this.ajaxParam.PRESTORE_LIST;
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    resetEvt() {
      let custPhone = $('.J_partner_headcont i').attr('username')
      this.condition = {
        custCode: undefined, // 客户编码
        custName: undefined, // 客户名称
        startDate: undefined, // 预存开始日期
        endDate: undefined, // 预存结束日期
        custPhone: custPhone, // 客户手机号
      }
      this.pageData.dateList = [];
    },
    add(){
      this.queryCommunityCustList()
    },
    queryCommunityCustList() {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_QUERYCOMMUNITYCUSTLIST;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.pageData.custList = res.data
          this.drawer.visible = true
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        custPhone: this.condition.custPhone
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    communityChange(value){
      let find = this.pageData.custList.find(item=>{
        return item.communityId === value
      })
      
      if(find){
        this.drawer.defaultValue.custPhone = this.condition.custPhone // 客户手机号
        this.drawer.defaultValue.custId = find.custId // 客户号
        this.drawer.defaultValue.custCode = find.cId // 客户编码
        this.drawer.defaultValue.custName = find.custName // 客户名称
        this.drawer.defaultValue.communityId = find.communityId // 真实项目ID
        this.drawer.defaultValue.mchNo = find.communityCode // 真实项目ID
        this.drawer.defaultValue.mchName = find.communityName // 真实项目

        this.queryResource()
        this.queryPrestoreScheme()
      }
      
    },
    queryResource() {
      const _this = this
      //搜索地址
      let url = this.ajaxParam.PRESTORE_QUERYRESOURCE;
      let successFunc = (res) => {
        if (res.code === "0000") {
          _this.pageData.resourceList = res.data

          _this.drawer.defaultValue.resInstId = undefined
          _this.drawer.defaultValue.resourceName = undefined
          _this.drawer.defaultValue.objType = undefined
          _this.drawer.defaultValue.resourceId = undefined
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        communityId: this.drawer.defaultValue.communityId,
        custId: this.drawer.defaultValue.custId,
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    resourceChange(value){
      let find = this.pageData.resourceList.find(item=>{
        return item.resourceCode === value
      })
      if(find){
        this.drawer.defaultValue.resourceName = find.resourceName
        this.drawer.defaultValue.objType = find.objType
        this.drawer.defaultValue.resourceId = find.resourceId
        this.drawer.defaultValue.resInstCodeExt = find.resInstCodeExt
      }
      
    },
    queryPrestoreScheme(){
      //搜索地址
      let url = this.ajaxParam.PRESTORE_QUERYPRESTORESCHEME;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.drawer.list = res.data ? res.data.map(item=>{
            return {
              ...item,
              payProjectAmount: 0
            }
          }) : []
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        communityId: this.drawer.defaultValue.communityId,
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    selectedRowKeysChange(selectedRowKeys){
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.drawer.selectedRowKeys = selectedRowKeys;
      this.totalAmountChange()
    },
    totalAmountChange(){
      let totalAmount = 0
      this.drawer.defaultValue.list = this.drawer.selectedRowKeys.reduce((list,el,i)=>{
        let find = this.drawer.list.find((item, index)=>{
          return el === index
        })
        if(find){
          list.push(find)
          totalAmount = NP.plus(totalAmount, find.payProjectAmount); 
        }
        return list
      },[])
      this.drawer.defaultValue.totalAmount = totalAmount
    },
    close() {
      this.drawer.visible = false;
      this.pageData.resourceList = []
      this.drawer = {
        visible: false,
        defaultValue: {
          resInstCodeExt: undefined, 
          accountBookType: undefined, // 账本类型
          custPhone: undefined, // 客户手机号
          custId: undefined, // 客户号
          custCode: undefined, // 客户编码
          custName: undefined, // 客户名称
          communityId: undefined, // 真实项目ID
          mchNo: undefined, // 门店号（项目编码）
          mchName: undefined, // 门店号（项目编码）
          objType: undefined, // 对象类型(资源类型)
          resourceId: undefined, // 资源id (铺位)
          resourceName: undefined, // 资源名称
          resourceCode: undefined, // 资源编码
          totalAmount: 0, // 缴费总金额
          payType: "85", // 账本类型  广发支付
          currentDate: moment(),
          remark: undefined, // 备注
          list: []
        },
        selectedRowKeys: [],
        columns: [
          { title: '方案名称', dataIndex: 'prestoreSchemeName', },
          { title: '账本类型', dataIndex: 'accountBookDesc', },
          { title: '可抵扣科目', dataIndex: 'payProject', },
          { title: '金额', dataIndex: 'payProjectAmount', scopedSlots: { customRender: 'payProjectAmount' }, },
        ],
        list: []
      }
    },
    submit(){
      let params = this.drawer.defaultValue
      //搜索地址
      let url = params.payType === '85' ? this.ajaxParam.PRESTORE_INSERPRESTORE : this.ajaxParam.PRESTORE_POSINSERPRESTORE;
      let requestParam = {
        ...params,
        currentDate: undefined
      }
      if(params.payType === '85'){
        let successFunc = (res) => {
          if (res.code === "0000") {
            this.close()
            this.search()
            this.getPayPaper(res.data)
          } else {
            this.$error({
              title: '提示',
              content: res.result,
            });
          }
        };
        let errorFunc = (res) => {
          this.$error({
            title: '提示',
            content: res.result,
          });
        };
        //fetch ajax提交数据
        ajax.fetch(url, requestParam, successFunc, errorFunc)
      }else{
        ajax.postExcelFile('导出数据.pdf', url, requestParam,()=>{
          this.close()
          this.search()
        })
      }
      
      
      
    },
    // // 获取支付页面
    getPayPaper(params) {
      //搜索地址
      let url = this.ajaxParam.POST_PAYBILL_GETPAYPAPER;
      const formdom = document.getElementById("formExport");
      formdom.action = url;
      document.getElementById("mchGroupCode").value = params.mchGroupCode;
      document.getElementById("mchSiteNo").value = params.mchSiteNo;
      document.getElementById("mchOrderNo").value = params.mchOrderNo;
      document.getElementById("mchOrderDttm").value = params.mchOrderDttm;
      document.getElementById("goodsTitle").value = params.goodsTitle;
      document.getElementById("goodsDetail").value = params.goodsDetail;
      document.getElementById("orderAmount").value = params.orderAmount;
      document.getElementById("chnlMchCode").value = params.chnlMchCode;
      document.getElementById("chnlMchName").value = params.chnlMchName;
      document.getElementById("mchCustId").value = params.mchCustId;
      document.getElementById("mchCustName").value = params.mchCustName;
      document.getElementById("mchCustIp").value = params.mchCustIp;
      document.getElementById("mchCustMac").value = params.mchCustMac;
      document.loginform.submit();
    },
    sysYcOrderInfo(prestoreOrderNo){
      //搜索地址
      let url = this.ajaxParam.PRESTORE_SYSYCORDERINFO;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.$message.success(res.result);
          this.search()
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
        prestoreOrderNo
      }
      //fetch ajax提交数据
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    }

  }
}
</script>

<style scoped>
.space-margin-bottom{
  margin-bottom: 10px;
}
</style>